module.exports = __webpack_public_path__ + "static/ec_dribbble-79ab5ee25d9779f26667200546092a0d.gif";